module.exports = __webpack_public_path__ + "static/media/action.9a52ad21.svg";